import styled from '@emotion/styled';
import YouTube from 'react-youtube';

export const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
`;

export const PlaceHolderContainer = styled.div`
  position: relative;
  width: 100%;
  padding-top: calc(56.25% / 2);
  padding-bottom: calc(56.25% / 2);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledYouTube = styled(YouTube)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
